import { IconHelpChat } from '@picsart/design-system/foundation/icons/IconHelpChat';

export type IconComponent = typeof IconHelpChat;

export interface SettingsLink {
  label: string;
  url: string;
  icon: IconComponent;
}

export enum SettingsPanelVariant {
  Dropdown = 'dropdown',
  Page = 'page',
}

export interface SettingsPanelProps {
  variant: SettingsPanelVariant;
  onBack?: () => void;
  isAuthorized?: boolean;
}
